import AuthService from './auth.service'
import PatientService from './patient.service'
import SurgeonService from './surgeon.service'
import FeedbackService from './feedback.service'
import UserService from './user.service'
import RegimenService from './regimen.service'
import ScheduleService from './schedule.service'
import ExerciseService from './exercise.service'
import CustomerService from './customer.service'
import CompanyService from './company.service'
import CallbackService from './callback.service'
import NotificationService from './notification.service'
import EventService from './event.service'
import SurgeryService from './surgery.service'
import Device from './device.service'
import Actioncase from './actioncases.service'
import PatientNotesService from './patientnotes.service'
import BillingService from './billing.service'
import SettingsService from './settings.service'
import RemindersService from './reminders.service'
import DefaultCarePlanService from './defaultcareplan.service'
import MaintenanceService from './maintenance.service'

class ServiceInterface {
  AuthService() {
    return new AuthService()
  }

  ActioncaseService() {
    return new Actioncase()
  }

  PatientService() {
    return new PatientService()
  }

  SurgeonService() {
    return new SurgeonService()
  }

  FeedbackService() {
    return new FeedbackService()
  }

  UserService() {
    return new UserService()
  }
  DeviceService() {
    return new Device()
  }

  RegimenServide() {
    return new RegimenService()
  }

  ScheduleService() {
    return new ScheduleService()
  }

  ExerciseService() {
    return new ExerciseService()
  }

  CustomerService() {
    return new CustomerService()
  }

  CompanyService() {
    return new CompanyService()
  }

  NotificationService() {
    return new NotificationService()
  }

  CallbackService() {
    return new CallbackService()
  }

  EventService() {
    return new EventService()
  }

  SurgeryService() {
    return new SurgeryService()
  }

  PatientNotesService() {
    return new PatientNotesService()
  }

  BillingService() {
    return BillingService
  }

  SettingsService() {
    return new SettingsService()
  }

  RemindersService() {
    return new RemindersService()
  }

  DefaultCarePlanService() {
    return new DefaultCarePlanService()
  }

  MaintenanceService() {
    return new MaintenanceService()
  }
}

export default new ServiceInterface()
